const ITEMS = [
  "Performance & Quality",
  "Accountability & Ownership",
  "Deadlines & Execution",
  "Communication",
  "Attendance, Leave & WFH",
  "Behaviour & Attitude",
  "Conflict & Teamwork",
  "Pay, Promotion & Recognition",
  "Probation, Discipline & Exit",
  "Leadership, Change & Expectations",
];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-mono text-xs uppercase tracking-[0.3em] text-[#a8a499]">
            {item}
          </span>
          <span aria-hidden="true" className="h-1.5 w-1.5 rotate-45 bg-[#4a463d]" />
        </span>
      ))}
    </div>
  );
}

export function Marquee() {
  return (
    <div
      aria-hidden="true"
      className="overflow-hidden border-y border-[#23211c] bg-ink py-4"
      data-testid="editorial-marquee"
    >
      <div
        className="flex w-max"
        style={{ animation: "marquee-drift 60s linear infinite" }}
      >
        <Row />
        <Row />
      </div>
    </div>
  );
}
